var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt--7",attrs:{"fluid":""}},[_c('create-vehicle-form',{ref:"createVehicle",on:{"success":_vm.created,"error":_vm.handleError}}),_c('fleet-table',{ref:"table",attrs:{"title":"Users"},on:{"addVehicle":_vm.showVehicleModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }